import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service3 = () => {
    const navigate = useNavigate(); // Initialize navigate

    // Function to handle navigation
    const handleNavigate = () => {
        navigate('/galleries'); // Navigate to the gallery page
    };

    return (
        <div className="about-events-container"> {/* Fixed missing <div> */}
            {/* First table for images and content */}

                <div className="about-events-images">
                    <img src="/images/shoot3.webp"/>
                    <img src="/images/shoot15.webp" />
                    <img src="/images/g6.webp"/>
                    <img src="/images/pre1.webp"/>
                </div>

                <div className="about-events-content">
                    <h2 className="about-header-service">Photo Shoot</h2>
<p>At Cocoloco Garden, we proudly offer our picturesque location for all your pre-shoot needs. Whether you're planning a bridal shoot, a pre-wedding shoot, a birthday photoshoot,
                             or capturing any other special moment, our entire garden is at your disposal to create stunning memories..</p>
                             <p>For more information about our pre-shoot packages and to explore the options we offer, please don’t hesitate to contact us. Click the link below to discover the details and book your pre-shoot at Cocoloco Garden today!</p>


                    <button className="service-button" onClick={handleNavigate}>
                        Click Here To See More Gallery ..
                    </button>
                </div>

        </div>
    );
};

export default Service3;
